class RcuCanvasUI {
	showCreateRcuModal = $state(false);
	showMapChannelModal = $state(false);
	selectedChannelId = $state<number | null>(null);

	openCreateModal() {
		this.showCreateRcuModal = true;
	}

	reset() {
		this.showCreateRcuModal = false;
		this.showMapChannelModal = false;
		this.selectedChannelId = null;
	}
}

export const rcuCanvasUI = new RcuCanvasUI();
